export enum ControlType {
    None = 0,
    TextBox = 1,
    ComboBox = 2,
    CheckBox = 3,
    RadioButton = 4,
    Options = 5,
    TextArea = 6,
    DataGrid = 7,
    TreeView = 8,
    TreeList = 9,
    Numeric = 10,
}

export const ControlTypeTranslations: Record<ControlType, string> = {
    [ControlType.None]: 'بدون',
    [ControlType.TextBox]: 'حقل نصي',
    [ControlType.ComboBox]: 'قائمة منسدلة',
    [ControlType.CheckBox]: 'مربع اختيار',
    [ControlType.RadioButton]: 'زر دائري',
    [ControlType.Options]: 'خيارات',
    [ControlType.TextArea]: 'منطقة نصية',
    [ControlType.DataGrid]: 'جدول بيانات',
    [ControlType.TreeView]: 'عرض شجري',
    [ControlType.TreeList]: 'قائمة شجرية',
    [ControlType.Numeric]: 'رقمي',
};
